var _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisamethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.889108,
    y: 0.861764,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.889108,
    y: 0.861764,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    stroke: "#F2F4F7",
    strokeWidth: 0.778215
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6546 16.9275H9.51734L7.91468 10.6334C7.83861 10.3439 7.67709 10.0879 7.43951 9.96729C6.84659 9.66412 6.19323 9.42285 5.48047 9.30116V9.05884H8.92338C9.39855 9.05884 9.75493 9.42285 9.81432 9.8456L10.6459 14.3857L12.7821 9.05884H14.8599L11.6546 16.9275ZM16.0478 16.9275H14.0294L15.6914 9.05884H17.7099L16.0478 16.9275ZM20.3212 11.2387C20.3806 10.8149 20.737 10.5726 21.1528 10.5726C21.8061 10.5117 22.5179 10.6334 23.1118 10.9355L23.4682 9.24138C22.8742 8.99906 22.2209 8.87737 21.628 8.87737C19.6689 8.87737 18.2434 9.9673 18.2434 11.48C18.2434 12.6307 19.2531 13.235 19.9659 13.599C20.737 13.9619 21.034 14.2043 20.9746 14.5672C20.9746 15.1117 20.3806 15.354 19.7877 15.354C19.075 15.354 18.3622 15.1725 17.7099 14.8693L17.3535 16.5645C18.0663 16.8667 18.8374 16.9883 19.5501 16.9883C21.7467 17.0481 23.1118 15.9593 23.1118 14.3249C23.1118 12.2667 20.3212 12.1461 20.3212 11.2387ZM30.1758 16.9275L28.5732 9.05884H26.8517C26.4953 9.05884 26.139 9.30116 26.0202 9.66412L23.0524 16.9275H25.1303L25.545 15.7778H28.098L28.3356 16.9275H30.1758ZM27.1487 11.1779L27.7416 14.1434H26.0796L27.1487 11.1779Z",
    fill: "#172B85"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisamethod);
export default __webpack_public_path__ + "static/media/Visa method.ba4cc227c4f3834ab6d776cb00a764d2.svg";
export { ForwardRef as ReactComponent };